export default __webpack_public_path__ + "static/media/Kasala Banner_2020-04.f3ce6ae6.png";